// extracted by mini-css-extract-plugin
export default {"label":"InputFieldWithLabel_label__TkW69","input":"InputFieldWithLabel_input__V5Gpx"};